import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b166a4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "events-admin-page" }
const _hoisted_2 = { class: "events-admin-header sv-page-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "sv-page-header__eyebrow" }, "Gestão de eventos"),
  /*#__PURE__*/_createElementVNode("h1", null, "Eventos e inscrições"),
  /*#__PURE__*/_createElementVNode("p", null, "Cadastre o próximo evento e acompanhe separadamente as inscrições de cada edição.")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-plus" }, null, -1))
const _hoisted_5 = { class: "events-filter-card card border-0 radius-7 bg-white mb-25" }
const _hoisted_6 = { class: "card-body p-20 p-md-25" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "events-filter-label",
  for: "event-filter"
}, "Evento exibido no dashboard", -1))
const _hoisted_8 = { class: "events-filter-row" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Selecione um evento", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-pencil-simple" }, null, -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-arrow-square-out" }, null, -1))
const _hoisted_16 = {
  key: 0,
  class: "events-selected-meta"
}
const _hoisted_17 = {
  key: 0,
  class: "alert alert-danger radius-7 mb-25",
  role: "alert"
}
const _hoisted_18 = {
  key: 1,
  class: "alert alert-success radius-7 mb-25",
  role: "status"
}
const _hoisted_19 = {
  key: 2,
  class: "events-empty-state"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-calendar-dots" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Selecione ou cadastre um evento", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Os indicadores permanecem vazios até que um evento seja selecionado.", -1))
const _hoisted_23 = [
  _hoisted_20,
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "card mb-25 border-0 radius-7 bg-white events-metric-card" }
const _hoisted_26 = { class: "card-body p-20" }
const _hoisted_27 = { class: "d-block text-body-tertiary fw-medium mb-6" }
const _hoisted_28 = { class: "mb-0 fw-black" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "card mb-25 border-0 radius-7 bg-white" }
const _hoisted_31 = { class: "card-body p-20 p-md-25" }
const _hoisted_32 = { class: "d-flex align-items-center justify-content-between mb-20" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-0 fw-bold" }, "Inscrições nos últimos 7 dias", -1))
const _hoisted_34 = ["disabled"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-arrow-clockwise" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 0,
  class: "col-xl-4"
}
const _hoisted_38 = { class: "card mb-25 border-0 radius-7 bg-white" }
const _hoisted_39 = { class: "card-body p-20 p-md-25" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-20 fw-bold" }, "Relação com a Videira", -1))
const _hoisted_41 = { class: "card mb-25 border-0 radius-7 bg-white" }
const _hoisted_42 = { class: "card-body p-20 p-md-25" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-20 fw-bold" }, "Distribuição por célula", -1))
const _hoisted_44 = {
  key: 0,
  class: "events-inline-empty"
}
const _hoisted_45 = {
  key: 1,
  class: "events-cell-list"
}
const _hoisted_46 = { class: "events-cell-bar" }
const _hoisted_47 = { class: "card mb-25 border-0 radius-7 bg-white" }
const _hoisted_48 = { class: "card-head events-table-head bg-white p-15 p-sm-20 p-md-25 radius-7" }
const _hoisted_49 = { class: "mb-5 fw-bold" }
const _hoisted_50 = { class: "text-body-tertiary fw-medium" }
const _hoisted_51 = { class: "events-search" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-magnifying-glass" }, null, -1))
const _hoisted_53 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_54 = {
  key: 0,
  class: "events-inline-empty"
}
const _hoisted_55 = {
  key: 1,
  class: "events-inline-empty"
}
const _hoisted_56 = { class: "table-responsive" }
const _hoisted_57 = { class: "table align-middle mb-0" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Data", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Nome", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "E-mail", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "WhatsApp", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Célula", -1))
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Expectativa", -1))
const _hoisted_66 = { class: "fw-bold" }
const _hoisted_67 = ["href"]
const _hoisted_68 = ["href"]
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { key: 1 }
const _hoisted_71 = { class: "events-expectation" }
const _hoisted_72 = { class: "events-pagination" }
const _hoisted_73 = ["disabled"]
const _hoisted_74 = ["disabled"]
const _hoisted_75 = {
  class: "events-modal",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "event-form-title"
}
const _hoisted_76 = { class: "events-modal-header" }
const _hoisted_77 = { class: "sv-page-header__eyebrow" }
const _hoisted_78 = { id: "event-form-title" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-x" }, null, -1))
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_82 = { class: "events-form-grid" }
const _hoisted_83 = { class: "events-field events-field--wide" }
const _hoisted_84 = { class: "events-field" }
const _hoisted_85 = { class: "events-field" }
const _hoisted_86 = { class: "events-field" }
const _hoisted_87 = ["min"]
const _hoisted_88 = { class: "events-field events-field--wide" }
const _hoisted_89 = { class: "events-field events-field--wide" }
const _hoisted_90 = { class: "events-field" }
const _hoisted_91 = { class: "events-check" }
const _hoisted_92 = { class: "events-check events-field--wide" }
const _hoisted_93 = { class: "events-field" }
const _hoisted_94 = { class: "events-field" }
const _hoisted_95 = { class: "events-field events-field--wide" }
const _hoisted_96 = ["onUpdate:modelValue"]
const _hoisted_97 = { class: "events-field events-field--wide" }
const _hoisted_98 = ["required"]
const _hoisted_99 = {
  key: 0,
  class: "events-image-preview events-field--wide"
}
const _hoisted_100 = ["src"]
const _hoisted_101 = { class: "events-check events-field--wide" }
const _hoisted_102 = { class: "events-check events-field--wide" }
const _hoisted_103 = { class: "events-field" }
const _hoisted_104 = { class: "events-field" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Selecione", -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Telefone", -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "E-mail", -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "CPF/CNPJ", -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Chave aleatória", -1))
const _hoisted_110 = [
  _hoisted_105,
  _hoisted_106,
  _hoisted_107,
  _hoisted_108,
  _hoisted_109
]
const _hoisted_111 = { class: "events-field" }
const _hoisted_112 = { class: "events-field" }
const _hoisted_113 = { class: "events-field events-field--wide" }
const _hoisted_114 = { class: "events-modal-footer" }
const _hoisted_115 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        class: "events-primary-button",
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCreateModal && _ctx.openCreateModal(...args)))
      }, [
        _hoisted_4,
        _createTextVNode(" Novo evento ")
      ])
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("select", {
            id: "event-filter",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedEventId) = $event)),
            class: "form-select",
            disabled: _ctx.eventsLoading,
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onEventSelection && _ctx.onEventSelection(...args)))
          }, [
            _hoisted_10,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: item.id,
                value: String(item.id)
              }, _toDisplayString(item.title) + " — " + _toDisplayString(_ctx.eventStatusLabel(item)), 9, _hoisted_11))
            }), 128))
          ], 40, _hoisted_9), [
            [_vModelSelect, _ctx.selectedEventId]
          ]),
          (_ctx.selectedEvent)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "events-secondary-button",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openEditModal && _ctx.openEditModal(...args)))
              }, [
                _hoisted_12,
                _createTextVNode(" Editar ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectedEvent?.is_active)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "events-secondary-button",
                disabled: _ctx.statusUpdating,
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleRegistrations && _ctx.toggleRegistrations(...args)))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(_ctx.selectedEvent.registrations_open ? 'ph ph-lock' : 'ph ph-lock-open')
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(_ctx.selectedEvent.registrations_open ? "Fechar inscrições" : "Abrir inscrições"), 1)
              ], 8, _hoisted_13))
            : _createCommentVNode("", true),
          (_ctx.selectedEvent)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: `/eventos/${_ctx.selectedEvent.slug}`,
                target: "_blank",
                class: "events-secondary-button"
              }, [
                _hoisted_15,
                _createTextVNode(" Ver página ")
              ], 8, _hoisted_14))
            : _createCommentVNode("", true)
        ]),
        (_ctx.selectedEvent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("span", {
                class: _normalizeClass(['events-badge', _ctx.selectedEvent.is_active ? 'active' : 'closed'])
              }, _toDisplayString(_ctx.eventStatusLabel(_ctx.selectedEvent)), 3),
              _createElementVNode("span", null, _toDisplayString(_ctx.formatEventDate(_ctx.selectedEvent.starts_at, _ctx.selectedEvent.ends_at)), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.selectedEvent.is_free ? "Evento gratuito" : _ctx.formatCurrency(_ctx.selectedEvent.price)), 1),
              _createElementVNode("span", null, "Slug: /eventos/" + _toDisplayString(_ctx.selectedEvent.slug), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true),
    (_ctx.successMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.successMessage), 1))
      : _createCommentVNode("", true),
    (!_ctx.selectedEventId && !_ctx.eventsLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_23))
      : (_ctx.selectedEventId)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("div", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metricCards, (metric) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: metric.label,
                  class: "col-sm-6 col-xl-3"
                }, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["events-metric-icon", metric.variant])
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(metric.icon)
                        }, null, 2)
                      ], 2),
                      _createElementVNode("span", _hoisted_27, _toDisplayString(metric.label), 1),
                      _createElementVNode("h3", _hoisted_28, _toDisplayString(metric.value), 1)
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.selectedEvent?.show_videira_relationship ? 'col-xl-8' : 'col-xl-12')
              }, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("button", {
                        class: "events-icon-button",
                        type: "button",
                        disabled: _ctx.isLoading,
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.fetchDashboard && _ctx.fetchDashboard(...args))),
                        "aria-label": "Atualizar dashboard"
                      }, _hoisted_36, 8, _hoisted_34)
                    ]),
                    _createVNode(_component_apexchart, {
                      type: "area",
                      height: "290",
                      options: _ctx.registrationsByDayChart,
                      series: [{ name: 'Inscrições', data: _ctx.charts.registrations_by_day.series }]
                    }, null, 8, ["options", "series"])
                  ])
                ])
              ], 2),
              (_ctx.selectedEvent?.show_videira_relationship)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _createVNode(_component_apexchart, {
                          type: "donut",
                          height: "290",
                          options: _ctx.relationshipChart,
                          series: _ctx.relationshipSeries
                        }, null, 8, ["options", "series"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                (_ctx.charts.registrations_by_cell.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, "Nenhum dado de célula disponível."))
                  : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.charts.registrations_by_cell, (cell) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: cell.label,
                          class: "events-cell-row"
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("strong", null, _toDisplayString(cell.label), 1),
                            _createElementVNode("span", null, _toDisplayString(cell.total) + " inscrição(ões)", 1)
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("span", {
                              style: _normalizeStyle({ width: _ctx.cellPercentage(cell.total) })
                            }, null, 4)
                          ])
                        ]))
                      }), 128))
                    ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", null, [
                  _createElementVNode("h5", _hoisted_49, "Inscrições de " + _toDisplayString(_ctx.selectedEvent?.title), 1),
                  _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.filteredRegistrations.length) + " registro(s)", 1)
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchTerm) = $event)),
                    type: "search",
                    placeholder: "Buscar participante"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.searchTerm,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, "Carregando inscrições..."))
                  : (_ctx.filteredRegistrations.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, "Nenhuma inscrição encontrada."))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("table", _hoisted_57, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _hoisted_58,
                                _hoisted_59,
                                _hoisted_60,
                                _hoisted_61,
                                _hoisted_62,
                                (_ctx.selectedEvent?.show_videira_relationship)
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_63, "Relação"))
                                  : _createCommentVNode("", true),
                                (_ctx.selectedEvent && !_ctx.selectedEvent.is_free)
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_64, "Pagamento"))
                                  : _createCommentVNode("", true),
                                _hoisted_65
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedRegistrations, (registration) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: registration.id
                                }, [
                                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(registration.created_at)), 1),
                                  _createElementVNode("td", _hoisted_66, _toDisplayString(registration.name), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("a", {
                                      href: `mailto:${registration.email}`
                                    }, _toDisplayString(registration.email), 9, _hoisted_67)
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("a", {
                                      href: _ctx.whatsappLink(registration.whatsapp),
                                      target: "_blank",
                                      rel: "noopener"
                                    }, _toDisplayString(registration.whatsapp), 9, _hoisted_68)
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(registration.cell_name || "Não informado"), 1),
                                  (_ctx.selectedEvent?.show_videira_relationship)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_69, _toDisplayString(registration.videira_relationship || "Não informado"), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.selectedEvent && !_ctx.selectedEvent.is_free)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_70, _toDisplayString(_ctx.paymentTimingLabel(registration.payment_timing)), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("td", _hoisted_71, _toDisplayString(registration.expectation), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("span", null, "Página " + _toDisplayString(_ctx.currentPage) + " de " + _toDisplayString(_ctx.totalPages), 1),
                          _createElementVNode("div", null, [
                            _createElementVNode("button", {
                              type: "button",
                              disabled: _ctx.currentPage === 1,
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                            }, "Anterior", 8, _hoisted_73),
                            _createElementVNode("button", {
                              type: "button",
                              disabled: _ctx.currentPage === _ctx.totalPages,
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                            }, "Próxima", 8, _hoisted_74)
                          ])
                        ])
                      ], 64))
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
    (_ctx.eventModalOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "events-modal-backdrop",
          onClick: _cache[32] || (_cache[32] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeEventModal && _ctx.closeEventModal(...args)), ["self"]))
        }, [
          _createElementVNode("section", _hoisted_75, [
            _createElementVNode("header", _hoisted_76, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.editingEventId ? "Editar evento" : "Novo evento"), 1),
                _createElementVNode("h2", _hoisted_78, _toDisplayString(_ctx.eventForm.title || "Informações do evento"), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                "aria-label": "Fechar",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeEventModal && _ctx.closeEventModal(...args)))
              }, _hoisted_80)
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[31] || (_cache[31] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveEvent && _ctx.saveEvent(...args)), ["prevent"]))
            }, [
              (_ctx.modalError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(_ctx.modalError), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("label", _hoisted_83, [
                  _createTextVNode("Título"),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.eventForm.title) = $event)),
                    required: "",
                    maxlength: "255",
                    type: "text"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.eventForm.title,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("label", _hoisted_84, [
                  _createTextVNode("Chamada curta"),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.eventForm.eyebrow) = $event)),
                    maxlength: "255",
                    type: "text"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.eventForm.eyebrow,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("label", _hoisted_85, [
                  _createTextVNode("Início"),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.eventForm.starts_at) = $event)),
                    required: "",
                    type: "datetime-local"
                  }, null, 512), [
                    [_vModelText, _ctx.eventForm.starts_at]
                  ])
                ]),
                _createElementVNode("label", _hoisted_86, [
                  _createTextVNode("Término"),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.eventForm.ends_at) = $event)),
                    min: _ctx.eventForm.starts_at,
                    required: "",
                    type: "datetime-local"
                  }, null, 8, _hoisted_87), [
                    [_vModelText, _ctx.eventForm.ends_at]
                  ])
                ]),
                _createElementVNode("label", _hoisted_88, [
                  _createTextVNode("Texto principal"),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.eventForm.hero_text) = $event)),
                    required: "",
                    maxlength: "3000",
                    rows: "3"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.eventForm.hero_text,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("label", _hoisted_89, [
                  _createTextVNode("Local"),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.eventForm.address) = $event)),
                    required: "",
                    maxlength: "500",
                    type: "text"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.eventForm.address,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("label", _hoisted_90, [
                  _createTextVNode("Inscrições até"),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.eventForm.registration_ends_at) = $event)),
                    required: "",
                    type: "datetime-local"
                  }, null, 512), [
                    [_vModelText, _ctx.eventForm.registration_ends_at]
                  ])
                ]),
                _createElementVNode("label", _hoisted_91, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.eventForm.registrations_open) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.eventForm.registrations_open]
                  ]),
                  _createTextVNode(" Iniciar com inscrições abertas")
                ]),
                _createElementVNode("label", _hoisted_92, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.eventForm.show_videira_relationship) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.eventForm.show_videira_relationship]
                  ]),
                  _createTextVNode(" Exibir a pergunta “Você conhece a Videira?” na inscrição")
                ]),
                _createElementVNode("label", _hoisted_93, [
                  _createTextVNode("Chamada da seção"),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.eventForm.content_eyebrow) = $event)),
                    maxlength: "255",
                    type: "text"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.eventForm.content_eyebrow,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("label", _hoisted_94, [
                  _createTextVNode("Título da seção"),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.eventForm.content_title) = $event)),
                    required: "",
                    maxlength: "500",
                    type: "text"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.eventForm.content_title,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("label", _hoisted_95, [
                  _createTextVNode("Texto da seção"),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.eventForm.content_text) = $event)),
                    required: "",
                    maxlength: "5000",
                    rows: "4"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.eventForm.content_text,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventForm.benefits, (_, index) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: index,
                    class: "events-field"
                  }, [
                    _createTextVNode("Benefício " + _toDisplayString(index + 1), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((_ctx.eventForm.benefits[index]) = $event),
                      maxlength: "500",
                      type: "text"
                    }, null, 8, _hoisted_96), [
                      [
                        _vModelText,
                        _ctx.eventForm.benefits[index],
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]))
                }), 128)),
                _createElementVNode("label", _hoisted_97, [
                  _createTextVNode("Imagem de fundo"),
                  _createElementVNode("input", {
                    required: !_ctx.editingEventId,
                    accept: "image/jpeg,image/png,image/webp",
                    type: "file",
                    onChange: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.onImageSelected && _ctx.onImageSelected(...args)))
                  }, null, 40, _hoisted_98)
                ]),
                (_ctx.imagePreview)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                      _createElementVNode("img", {
                        src: _ctx.imagePreview,
                        alt: "Pré-visualização da imagem"
                      }, null, 8, _hoisted_100)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("label", _hoisted_101, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.eventForm.is_free) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.eventForm.is_free]
                  ]),
                  _createTextVNode(" Evento gratuito")
                ]),
                (!_ctx.eventForm.is_free)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("label", _hoisted_102, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.eventForm.allows_payment_on_event_day) = $event)),
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.eventForm.allows_payment_on_event_day]
                        ]),
                        _createTextVNode(" Permitir que o participante escolha pagar no dia do evento")
                      ]),
                      _createElementVNode("label", _hoisted_103, [
                        _createTextVNode("Valor"),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.eventForm.price) = $event)),
                          required: "",
                          min: "0.01",
                          step: "0.01",
                          type: "number"
                        }, null, 512), [
                          [_vModelText, _ctx.eventForm.price]
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_104, [
                        _createTextVNode("Tipo da chave Pix"),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.eventForm.pix_key_type) = $event)),
                          required: ""
                        }, _hoisted_110, 512), [
                          [_vModelSelect, _ctx.eventForm.pix_key_type]
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_111, [
                        _createTextVNode("Chave Pix"),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.eventForm.pix_key) = $event)),
                          required: "",
                          maxlength: "255",
                          type: "text"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.eventForm.pix_key,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_112, [
                        _createTextVNode("WhatsApp do comprovante"),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.eventForm.receipt_whatsapp) = $event)),
                          required: "",
                          maxlength: "20",
                          type: "tel"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.eventForm.receipt_whatsapp,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_113, [
                        _createTextVNode("Instruções de pagamento"),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.eventForm.payment_instructions) = $event)),
                          maxlength: "2000",
                          rows: "3"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.eventForm.payment_instructions,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("footer", _hoisted_114, [
                _createElementVNode("button", {
                  type: "button",
                  class: "events-secondary-button",
                  onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.closeEventModal && _ctx.closeEventModal(...args)))
                }, "Cancelar"),
                _createElementVNode("button", {
                  type: "submit",
                  class: "events-primary-button",
                  disabled: _ctx.eventSaving
                }, _toDisplayString(_ctx.eventSaving ? "Salvando..." : _ctx.editingEventId ? "Salvar alterações" : "Criar e ativar evento"), 9, _hoisted_115)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}